var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUwLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00518A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "object-1",
    className: "st0",
    d: "M59.9,153.2c1.2-0.8,4.3-2,5.9-2.7s1.2-1.6,0.8-2.7c-2-6.3-3.1-12.9-3.1-19.6c0-35.3,28.6-64.4,64.4-64.4 c35.3,0,64.4,29,64.4,64.4c0,9-2,17.7-5.5,25.5c-0.4,0.4-0.4,1.6,0.8,2s4.7,2.4,5.9,2.7c1.2,0.4,2,0,2.4-1.2 c3.9-9,5.9-18.8,5.9-29.4c0-40.8-33.4-74.2-74.2-74.2s-74.2,33.4-74.2,74.2c0,8.2,1.6,16.5,3.9,23.9C57.9,153.2,58.7,154,59.9,153.2 L59.9,153.2z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "object-2",
    className: "st0",
    d: "M41.1,161.8c1.6-0.8,6.7-3.1,8.2-3.9c1.6-0.8,1.2-2,0.8-2.4c-3.1-8.6-4.7-18-4.7-27.5 c0-45.5,36.9-82.4,82.4-82.4s82.4,36.9,82.4,82.4c0,11.8-2.4,22.8-6.7,32.6c-0.4,0.4-0.8,1.6,0.8,2.4c1.2,0.4,7.1,3.1,8.2,3.5 c1.2,0.4,2,0.4,2.4-1.2c5.1-11.4,7.8-24.3,7.8-37.7c0-52.2-42.4-95-95-95c-52.2,0-95,42.8-95,95c0,11.4,2,22.4,5.9,33 C39.1,161.4,39.5,162.6,41.1,161.8L41.1,161.8z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "object-3",
    className: "st0",
    d: "M15.6,173.6c2-0.8,12.9-5.9,14.9-7.1c2-0.8,1.2-2.4,0.8-3.1c-3.9-11-6.3-23.2-6.3-35.7 C25,70.8,70.9,24.9,127.8,24.9c56.5,0,102.8,46.3,102.8,102.8c0,14.5-3.1,27.9-8.2,40.4c-0.4,0.8-0.8,2.4,1.2,3.1 c2,0.8,12.6,5.5,14.1,6.3c1.6,0.8,2.7,0.4,3.5-1.6c6.3-14.9,9.8-31,9.8-47.9C251,60.2,195.7,4.9,127.8,4.9 C59.9,4.9,4.6,60.2,4.6,128.1c0,15.7,2.7,30.6,8.2,44.3C13.2,173.2,14,174.8,15.6,173.6L15.6,173.6z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "object-4",
    className: "st0",
    d: "M127.8,101.4c7.1,0,13.3-5.9,13.3-13.3s-5.9-13.3-13.3-13.3c-7.5,0-13.3,5.9-13.3,13.3 C114.8,95.5,120.7,101.4,127.8,101.4L127.8,101.4z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "object-5",
    className: "st0",
    d: "M132.9,170.5c2.7,0,4.7-2,4.7-4.7v-29c0-3.5,2.7-8.2,5.1-11l27.1-27.1c2-2,2-4.7,0-6.7l-5.1-5.1 c-2-2-4.7-2-6.7,0l-24.7,24.7c-1.6,1.6-2.7,2.7-5.9,2.7s-4.3-1.2-5.9-2.7L96.8,86.9c-2-2-4.7-2-6.7,0L85,92c-2,2-2,4.7,0,6.7 l27.1,27.1c2.7,2.7,5.1,7.5,5.1,11v29c0,2.7,2,4.7,4.7,4.7H132.9L132.9,170.5z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "object-6",
    className: "st0",
    d: "M218.8,180.7c-4.7,1.6-13.3,10.2-17.3,13.7l-1.2,0.4c1.2-1.6,7.5-9,9-11.8c4.7-7.8-4.3-15.3-14.1-9.4 c-3.5,2-9.8,8.6-12.9,11l-0.8,0.4c1.2-1.2,6.7-8.6,8.2-11c4.3-6.3-4.7-12.2-12.6-7.5c-5.5,3.1-9.8,7.8-14.5,11.4h-0.8 c1.2-1.2,4.3-4.7,5.5-5.9c4.7-5.1-2-11-8.6-7.5c-6.7,3.5-16.1,12.9-26.3,19.6c4.7,2.7,13.3,2.7,26.7,8.6c13.3,5.9,17.7,19.2,9,29.8 c-8.2,9.8-20.4,6.7-31,3.1c-12.2-3.9-16.5-7.8-31.4-12.9c-9.8-3.5-13.7-3.1-13.3-6.3c0-3.1,8.6-1.2,16.5,1.6 c21.6,7.8,50.6,25.9,57.7,6.7c5.5-15.3-19.6-22-29-23.5c-13.3-2.4-22.8-12.2-34.1-18.4c-17.7-9.4-31-9.8-40.8-7.8 c-10.6,2-25.9,10.6-35.3,16.1c-6.3,3.9-5.9,9.8,0.4,18.4c22.4,31.8,59.3,52.2,100.8,52.2c44.3,0,82.8-23.5,104.8-58.5 C237.3,185,229.8,176.7,218.8,180.7L218.8,180.7z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00518a; #7ea0c3; #00518a",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwLoadingIcon);
export default __webpack_public_path__ + "static/media/uw-loading-icon.e15b0cfe71453fb2f4bbbf7630acbb65.svg";
export { ForwardRef as ReactComponent };